namespace AgerLMS.LMS {
    export interface CheckCouponCodeResponse extends Serenity.ServiceResponse {
        DiscountAmount?: number;
        DiscountId?: number;
        Discount?: DiscountsRow;
        CourseDiscounts?: { [key: number]: number };
    }
}
